import PaymentInformationModal from './PaymentInformationModal';

const Paywall2Modal = ({
  data,
  hideModal,
}: {
  data?: any;
  hideModal: () => void;
}) => (
  <PaymentInformationModal
    data={{ ...data, paywallVariant: 'paywall2' }}
    hideModal={hideModal}
  />
);

export default Paywall2Modal;
